import React from 'react';
import { Helmet } from 'react-helmet';
import Support from '../components/Support';

const SupportRoute = () => {
  return (
    <>
      <Helmet>
        <title>ragobble - Support</title>
        <meta name="description" content="Get support for the AskPics app and contact our team." />
        <link rel="canonical" href="https://ragobble.com/support" />
      </Helmet>
      <div>
        <main>
          <Support />
        </main>
      </div>
    </>
  );
};

export default SupportRoute;
